import axios from 'axios';

export default axios.create({
  baseURL: process.env.VUE_APP_API_ROOT + '/' + process.env.VUE_APP_API_VERSION,
  headers: {
    'Content-Type': 'application/json, multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    Accept: 'application/json'
  }
});
